export enum FlightPermissions {
  ALL = "Travel:Flights:*",
  READ = "Travel:Flights:Read",
  WRITE = "Travel:Flights:Write",
}

export function hasFlightAccess(userPermissions: string[]): boolean {
  return userPermissions.some((p) =>
    [FlightPermissions.READ, FlightPermissions.ALL, "*"].includes(p)
  );
}
